<template>
    <v-main> 
<!-- header -->                                 
        <v-card class="ma-2">
            <v-card-title class="justify-center">{{ heho.heho_type }} : {{ heho.hust_oms }} {{ heho.heho_code }} <v-chip :color=heho.hust_kleur class="mx-4"> {{heho.hust_code}} </v-chip> <send_mail_info :heho_encrid="heho.heho_encrid" :key="heho.heho_encrid" class="mb-1 ml-4"/><btn_audit table="heho" :encrid="heho_encrid" :size=30 tooltip="audit of host booking"/></v-card-title>                              
            <v-card-text>
                <v-row>
                    <v-col cols="11">     
                        <!-- <v-chip v-if="heho.heho_overrule_plrc" color="warning" class="mx-4"> Not a standard bookable period </v-chip> -->
                        <v-chip v-for="(item, index) in heho.warnings"  :key="index" :color="item.color" class="mx-4"> {{ item.text }} </v-chip>
                    </v-col> 
                                
                    <v-col cols="1">
                        <mail_button v-if="heho.heho_type!=='ImportedBooking'" :mails="heho.mails" :encrid="heho.heho_encrid" @showDialog="showMailDialog" />   
                    </v-col>
                </v-row>
                <v-row class="pa-0 ma-0">
                    <v-col class="pa-2" cols="12">
                        Contract: {{ heho.heho_contract }}
                    </v-col>
                </v-row>  
                <v-row class="pa-0 ma-0" v-for="(hhpl,h) in heho.hhpl" :key="h">
                    <v-col class="px-2 py-0" cols="12">
                        Planning: {{ hhpl.hhpl_plan_code }} <span class="px-4" v-if="hhpl.hhpl_operto_id!==''">Operto ID planning: {{ hhpl.hhpl_operto_id }}</span>
                    </v-col>
                </v-row>      
            </v-card-text>                              
            <v-row class="ma-2 mb-3"><v-divider></v-divider></v-row>
            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="2" class="pr-4">
                        <v-text-field v-model="heho.heho_dt" readonly label="Booking date"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pr-4">
                        <v-text-field v-model="heho.heho_booked_by" readonly label="Booked by"></v-text-field>
                    </v-col>
                    <v-col cols="3" class="pr-4">
                        <v-text-field v-model="heho.heho_van_samengesteld" readonly label="Arrival"></v-text-field>
                    </v-col>
                    <v-col cols="3" class="pr-4">
                        <v-text-field v-model="heho.heho_tm_samengesteld" readonly label="Departure"></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-text-field v-model="heho.heho_aant_nacht" readonly label="Nights"></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <note_button v-if="heho.heho_type!=='ImportedBooking'" :notts="heho.notts_stay" :encrid="heho.heho_encrid" noto_oms="Stayperiod remark" @showDialog="showNoteDialog" />   
                    </v-col>
                </v-row>
            </v-card-text>

        </v-card>

<!-- body = updateble values -->
        <v-card class="ma-2">
            <v-row no-gutters>
                <v-col cols="6">
                    <v-card-title>Guest</v-card-title>
                    <v-card-text>
                        <guest :isReadOnly="isDisabled(heho)" :guest="guest" @updateData="updateData"/>      
                    </v-card-text>                            
                </v-col> 
                <v-col cols="6" class="pl-4">
                    <v-card-title>Travelparty
                        <v-col cols="1" class="pr-2 row-pointer">
                            <v-avatar :color="heho.heho_hegs_color" size=30 @click="$refs.hehoTravelParty.open(heho.heho_encrid);">{{ heho.heho_aant_hegs }}</v-avatar>  
                        </v-col>
                        <v-col>
                            <v-btn color="primary" small @click="$refs.hehoTravelParty.open(heho.heho_encrid);">Travelparty guest info</v-btn>
                        </v-col>
                        <v-col></v-col>
                        <v-col></v-col>
                        <v-col>
                            <note_button v-if="heho.heho_type!=='ImportedBooking'" :notts="heho.notts_party" :encrid="heho.heho_encrid" noto_oms="Travelparty remark" @showDialog="showNoteDialog" />   
                        </v-col>
                    </v-card-title>
                    <v-card-text>
                        <travelparty :isReadOnly="isDisabled(heho)" :numRowsRemark="0" :travelparty="travelparty" @updateData="updateData"/>                        
                    </v-card-text>
                </v-col>
            </v-row> 
            <v-row no-gutters>
                <v-col cols="12">
                    <v-card flat>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" small v-on:click="actionClick('bknDny')" v-if="heho.hust_code==='A-STD'">Book/Deny</v-btn>
                            <v-btn color="primary" :disabled="isDisabled(heho)" small v-on:click="updateHeho(heho.heho_type)"><v-icon medium class="mr-2" v-if="buttonIcon!==''">{{ this.buttonIcon }}</v-icon>{{ this.buttonCaption }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>                    
            </v-row>
        </v-card>

        <mails_dialog ref="mailDialog"/>
        <warning ref="warning" @processWarning="processWarning"/>
        <question ref="question" :heho_encrid="heho.heho_encrid" @processQuestion="processQuestion"/>
        <bknDnyHeho ref="bknDnyHeho" @actionClick="actionClick"/>
        <cancelHeho ref="cancelHeho"></cancelHeho>
        <hehoTravelParty ref="hehoTravelParty"></hehoTravelParty>
        <navbar title="ARES - Host booking" :actions="heho.action_items" :home="false" :notts="heho.notts" :mails="heho.mails" @actionClick="actionClick"/>
        <nott ref="nott"/>
    </v-main>
</template>

<script>
    import mail_button from '@/components/ui/buttons/btn_mails.vue'
    import note_button from '@/components/ui/buttons/btn_notts.vue'
    import btn_audit from "@/components/ui/buttons/btn_audit.vue";
    import navbar from '@/components/ui/navbars/navbar.vue';
    import nott from "@/components/nott.vue";

    import send_mail_info from '@/components/plan/heho/send_mail_info.vue'
    import mails_dialog from '@/components/plan/heho/showMails.vue'
    import travelparty from '@/components/plan/heho/travelparty.vue'
    import bknDnyHeho from '@/components/plan/heho/bknDnyHeho.vue'
    import question from '@/components/plan/heho/question.vue'
    import warning from '@/components/plan/heho/warning.vue'
    import guest from '@/components/plan/heho/guest.vue'

    import hehoTravelParty from "@/views/heho/hehoTravelParty.vue";
    import cancelHeho from "@/views/heho/cancelHeho.vue";

export default {
    components: {
        btn_audit,
        cancelHeho,
        travelparty,
        guest,
        mail_button,
        note_button,
        mails_dialog,          
        send_mail_info,
        warning,
        question,
        hehoTravelParty,
        bknDnyHeho,
        navbar,
        nott,
    },
    props: ['heho_encrid', 'huis_encrid'],
    data() {
        return {
            heho: {
                action_items: [],  /* moet pre defined ivm length check */
                hhpl: [],
                notts: -1,
                mails: -1,
                heho_encrid: "",
            },
            snackbar: false,
            snackbarMessage: '',
            travelparty: { adults: '0', children: '0', babys: '0', pets: '0', remark: '' },
            guest: { name: '', email: '', telephone: '', address: '', city: '' },
            mailSend: false,
            buttonCaption: 'Update',
            buttonIcon: '',
        }

    },
    mounted() {
        this.getHeho();
    },
    methods: {
        actionClick(action) {
            if (action == "mails") {
                this.$refs.mailDialog.open(this.heho_encrid);
            }
            if (action == "nott") {
                this.$refs.nott.open("heho", this.heho_encrid, "all");
            }
            if (action == "bknDny") {
                this.$refs.bknDnyHeho.openDialog(this.heho_encrid);
            }
            if (action == "Cancel") {
                this.$refs.cancelHeho.open(this.heho_encrid, this.huis_encrid);
            }
            if (action == "Confirmation") {
                this.$refs.question.open(this.heho_encrid, this.huis_encrid);
            }  
            if (action == "Refresh") {
                this.getHeho();
            }             
        },
        showMailDialog(encrid){
            this.$refs.mailDialog.open(encrid);
        },  
        showNoteDialog(encrid, note_type){
            this.$refs.nott.open("heho", encrid, note_type);
        }, 
        updateData(data){
            this[data.field] = data.value;
        },        
        isDisabled(heho) {
            return (heho.heho_type!=='HostBooking'&&heho.heho_type!=='importedBooking')
        },
        getHeho(){
            this.$axios
                .post("ares/json/ares/heho/getHeho.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHeho"
                    },
                    getHeho: {
                        heho_encrid: this.heho_encrid,
                        huis_encrid: this.huis_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.heho = res.data.getHeho;
                        document.title = 'Host booking ' + res.data.getHeho.heho_code;
                        // create travelparty and guest object
                        this.travelparty = {
                            adults: this.heho.heho_aant_volw,
                            children: this.heho.heho_aant_kind,
                            babys: this.heho.heho_aant_baby,
                            pets: this.heho.heho_aant_hd,
                            remark: this.heho.heho_opm
                        };
                        this.guest = {
                            name: this.heho.heho_klnt_naam,
                            email: this.heho.heho_klnt_email,
                            telephone: this.heho.heho_klnt_telefoon,
                            address: this.heho.heho_klnt_adres,
                            city: this.heho.heho_klnt_plaats
                        };
                    }
                });            
        },  
        resendConfirmation(){
            console.log('resend');
            this.$axios
                .post("ares/json/ares/heho/sendConfirmation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "resendMail"
                    },
                    resendMail: {            
                        heho_encrid: this.heho.heho_encrid,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error);
                        // laten we hopen dat dit nooit gebeurt, anders zetten we de gebruiker vast in dit dialog met een melding of iets (komt later)
                    } else { 
                        this.heho.mails += res.data.resendMail.mail_sent;
                    }
                });
        },
        processUpdate(){
            console.log('do it');
            this.$axios
                .post("ares/json/ares/heho/updHeho.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHeho"
                    },
                    updHeho: {            
                        heho_encrid: this.heho.heho_encrid,
                        guest: this.guest,
                        travelparty: this.travelparty,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error);
                        // laten we hopen dat dit nooit gebeurt, anders zetten we de gebruiker vast in dit dialog met een melding of iets (komt later)
                    } else { 
                        this.mailSend = true;
                        this.buttonCaption = 'Done';
                        this.buttonIcon = 'mdi-check-circle-outline';
                        this.heho.mails += res.data.updHeho.mail_sent;
                    }
                });
        },
        processWarning(answer){
            answer==='yes' ? this.processUpdate() : false;
        },    
        processQuestion(answer){
            answer==='yes' ? this.resendConfirmation() : false;
        },            
        updateHeho(type) {
            this.$refs.warning.open(type);
        }
    }
};

</script> 

<style scoped>
/* .flex{
    display: flex;
    flex-direction: row;
} */
</style>